import { Mode } from "types/Mode";

import { baseRestApi } from "../baseRestApi";
import { QuoteGetResponse } from "./types/getQuote";

const API_ROOT = "/shipper/quotes";
module.hot?.accept();

type UrlParams = { quoteId: number; mode: Mode };

type QueryArgs = { urlParams: UrlParams };

const getQuoteApi = baseRestApi.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",

  endpoints: (builder) => ({
    getQuote: builder.query<QuoteGetResponse, QueryArgs>({
      query: (params) => ({
        url: `${API_ROOT}/${params.urlParams.mode}/${params.urlParams.quoteId}`,
        method: "GET",
      }),
    }),
  }),
});

export default getQuoteApi;

export const { useGetQuoteQuery } = getQuoteApi;
